import React from 'react';
import styles from '../../styles/Building MGMT/UnitApplicationsHeader.module.css';

const UnitApplicationsHeader = ({ unit, activeTab, setActiveTab, handleBack }) => {
  if (!unit) return null; // Ensures unit exists before rendering

  return (
    <div className={styles.header}>
      <div className={styles.topRow}>
        <button className={styles.backBtn} onClick={handleBack}>← Back to Building</button>
      </div>
      <h2 className={styles.headerTitle}>
        Manage Applications for Unit #{unit.number}
      </h2>
      <div className={styles.tabs}>
        {['Applications', 'Tours', 'Messages', 'Offer'].map(tab => (
          <button
            key={tab}
            className={`${styles.tabButton} ${activeTab === tab ? styles.active : ''}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>
    </div>
  );
};

export default UnitApplicationsHeader;
